import { combineReducers } from 'redux';
import accessibilityReducer from './accessibilitySlice';
import basicDetailsReducer from './basicDetailsSlice';
import templateReducer, { defaultTemplateSlice } from './templateSlice';
import candidateReducer from './candidateSlice';
import timeLineReducer from './timeLineSlice';
import currentWorkflowItemReducers, { firstWorkflowItemSlice } from './currentWorkflowItemSlice';
import headerDetailsReducers from './headerDetailsSlice';
import headerOptionsReducers from './headerOptionsSlice';
import companySettingsReducers from './companySettingsSlice';
import genericErrorReducers from './genericErrorSlice';
import workflowSessionReducers from './workflowSessionSlice';
import projectSettingsReducers from './projectSettingsSlice';

export const reducers = combineReducers({
  basicDetails: basicDetailsReducer,
  template: templateReducer,
  candidate: candidateReducer,
  currentWorkflowItem: currentWorkflowItemReducers,
  accessibility: accessibilityReducer,
  headerDetails: headerDetailsReducers,
  defaultTemplate: defaultTemplateSlice.reducer,
  timeLine: timeLineReducer,
  headerOptions: headerOptionsReducers,
  companySettings: companySettingsReducers,
  genericError: genericErrorReducers,
  firstWorkflowItem: firstWorkflowItemSlice.reducer,
  workflowSession: workflowSessionReducers,
  projectSettings: projectSettingsReducers,
});
